module.exports = __webpack_public_path__ + "img/YellowArrows_left.52f3a374.svg";